module.exports = __webpack_public_path__ + "static/media/7camhung.3fef1867.jpg";